import { EpisodeOrderType } from '@diritto/common/episode/constants';
import { QueryKey } from 'constants/reactQuery';

export const studioQueryKey = {
  contents: [QueryKey.WsContent] as const,
  content: (contentId: number) => [...studioQueryKey.contents, contentId] as const,

  contentList: (contentIds: number[]) => [...studioQueryKey.contents, contentIds.join('|')] as const,
  contentEpisodeList: (contentId: number, orderType: EpisodeOrderType) =>
    [...studioQueryKey.content(contentId), orderType] as const,

  episodes: [QueryKey.WsEpisode] as const,
  episodeEdit: (episodeId: number) => [...studioQueryKey.episodes, episodeId, QueryKey.Edit] as const,

  wsEpisodeOpenedInMonth: (yearMonth: string) =>
    [...studioQueryKey.contents, ...studioQueryKey.episodes, 'firstOpenedInMonth', yearMonth] as const,

  wsContentSynopsis: (contentId: number) => [...studioQueryKey.content(contentId), 'synopsis'] as const,
};
